import { Component, OnDestroy, OnInit } from '@angular/core';
import { HxAuthService, NotifierService } from 'hx-services';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { NgIf } from '@angular/common';
import { RouterOutlet } from '@angular/router';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    imports: [NgIf, RouterOutlet, TranslocoPipe]
})
export class AppComponent implements OnDestroy, OnInit {
  constructor(
    public auth: HxAuthService,
    private notifierService: NotifierService,
    private tr: TranslocoService,
  ) {
  }

  ngOnInit() {
    this.notifierService.start();
    this.tr.setDefaultLang('ru');
    this.tr.setActiveLang('ru');
  }

  ngOnDestroy() {
    this.notifierService.destroy();
  }
}
